import React from 'react';
import './ContactSection.css'

const ContactSection = ({ id }) => {
  return (
    <div id={id} className="contact-impressum-section">
      <div className="contact-section">
        <div className="contact-col contact-left">
          <h2>Kontakt</h2>
        </div>
        <div className="contact-col contact-center">
          <a href="mailto:info-natuerlik@gmx.de" className="contact-link">info-natuerlik@gmx.de</a>
        </div>
        <div className="contact-col contact-right">
          <a href="/impressum.html" className="impressum-link">Impressum</a>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
